module.exports = __webpack_public_path__ + "static/media/347.c5eca640.webp";